<app-panel-header-image-view [pretitle]="'Indoor World Series' | transloco" [title]="title | transloco" banner_image="../../../modules/custom/wa_angular/app/assets/images/indoor-series/banner.jpg">
    <app-third-nav-tab-component [elements]="routes"></app-third-nav-tab-component>
</app-panel-header-image-view>
<div class="pane-indoor">
  <app-app-content-page-wrapper>
   <router-outlet></router-outlet>
   <app-news-panel [title]="'related_news' | transloco"  [news]="news" *ngIf="news && news.length > 0"></app-news-panel>
  </app-app-content-page-wrapper>
</div>

